module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_1.62e5f37a.png";